import { type FC } from 'react';

import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import {
  selectSpecContractIsFail,
  selectSpecContractIsOpenByKind,
} from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import { BuyExtendTimeForContract } from '../BuyExtendTimeForContract/BuyExtendTimeForContract';
import { CompleteSpecContractButton } from '../CompleteSpecContractButton/CompleteSpecContractButtton';
import { LaterButton } from '../LaterButton/LaterButton';
import { OpenSpecContractButton } from '../OpenSpecContractButton/OpenSpecContractButton';
import { RejectSpecContractButton } from '../RejectSpecContractButton/RejectSpecContractButton';

interface ContractButtonsProps {
  kind: SpecContractType | PaidSpecContractType;
  isContractExpired?: boolean;
}

const ContractButtons: FC<ContractButtonsProps> = ({
  kind,
  isContractExpired,
}) => {
  const isOpen = useAppSelector((state) =>
    selectSpecContractIsOpenByKind(state, kind),
  );

  const isFail = useAppSelector((state) =>
    selectSpecContractIsFail(state, kind),
  );

  if (isContractExpired) {
    return <BuyExtendTimeForContract kind={kind} />;
  }

  if (isOpen) {
    return <CompleteSpecContractButton kind={kind} />;
  }

  if (isFail) {
    return <RejectSpecContractButton kind={kind} />;
  }

  return (
    <div className="w-full gap-2 flex px-4 pb-4">
      <LaterButton />
      <OpenSpecContractButton kind={kind} />
    </div>
  );
};

export { ContractButtons };
